import React, { useEffect, useState } from "react";
import { getEncounters, getTeams, deleteEncounter } from "../services/firestoreService";
import { Container, Typography, Card, IconButton, Grid } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const PastEncounters = ({ updatePastEncounters }) => {
  const [pastEncounters, setPastEncounters] = useState([]);

  useEffect(() => {
    const fetchPastEncounters = async () => {
      try {
        const encountersData = await getEncounters();
        const teamsData = await getTeams();
        const now = new Date();
        const cutoff = new Date(now.getTime() - 48 * 60 * 60 * 1000);

        const pastEncounters = encountersData
          .filter(encounter => new Date(encounter.date) < cutoff)
          .map(encounter => ({
            ...encounter,
            team1Name: teamsData.find(team => team.id === encounter.team1)?.name || "Unbekannt",
            team2Name: teamsData.find(team => team.id === encounter.team2)?.name || "Unbekannt",
            date: new Date(encounter.date),
          }));

        setPastEncounters(pastEncounters);
      } catch (error) {
        console.error("Fehler beim Abrufen vergangener Begegnungen:", error);
      }
    };

    fetchPastEncounters();
  }, []);

  const handleDeleteEncounter = async (encounterId) => {
    const confirmDelete = window.confirm("Möchtest du diese Begegnung wirklich löschen?");
    if (confirmDelete) {
      await deleteEncounter(encounterId);
      setPastEncounters(prevEncounters => prevEncounters.filter(encounter => encounter.id !== encounterId));

      if (typeof updatePastEncounters === "function") {
        updatePastEncounters(); // 🔥 Jetzt sollte kein Fehler mehr auftreten
      }
    }
  };

  return (
    <Container maxWidth="md">
      <Typography variant="h4" gutterBottom align="center">
        Vergangene Begegnungen
      </Typography>

      {pastEncounters.length === 0 ? (
        <Typography align="center">Keine vergangenen Begegnungen vorhanden.</Typography>
      ) : (
        pastEncounters.map((encounter) => (
          <Card key={encounter.id} sx={{ mb: 2, p: 2 }}>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid item xs={8}>
                <Typography variant="h6">
                  {`${encounter.team1Name} vs ${encounter.team2Name} (${encounter.date.toLocaleDateString()})`}
                </Typography>
              </Grid>
              <Grid item>
                <IconButton onClick={() => handleDeleteEncounter(encounter.id)} color="error">
                  <DeleteIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Card>
        ))
      )}
    </Container>
  );
};

export default PastEncounters;
